<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="9000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card class="box">
            <v-row fluid justify="center">
                <v-radio-group v-model="print_type" row>
                    <v-radio label="Print Bulk Icards" value="Bulk" @change="icard_data_rem_students = []"></v-radio>
                    <v-radio label="Print Specific Icards" value="Specific"
                        @change="icard_data_rem_students = []"></v-radio>
                </v-radio-group>
            </v-row>
            <template v-if="print_type == 'Bulk'">
                <v-row justify="center">
                    <v-col sm="3" md="3">
                        <v-autocomplete class="no-display" :items="std_list" item-value="id" item-text="standard"
                            v-model="std" label="Select Standard" dense rounded outlined :loading="std_loader"
                            color="#0F2027"></v-autocomplete>
                    </v-col>
                    <v-col sm="3" md="3">
                        <v-autocomplete class="no-display" :items="div_list" item-value="id" item-text="division"
                            v-model="div" label="Select Division" dense rounded outlined
                            color="#0F2027"></v-autocomplete>
                    </v-col>
                    <v-col sm="2">
                        <v-autocomplete color="#0F2027" dense rounded required v-model="status" :items="status_list"
                            item-text="name" item-value="id" label="Status" outlined persistent-hint
                            hint="Select Status" />
                    </v-col>
                    <v-col sm="2">
                        <v-text-field dense rounded required outlined persistent-hint hint="Items Per Pages"
                            v-model="itemsPerPage" label="Items Per Pages"></v-text-field>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-col sm="4" v-if="std && div && status">
                        <v-btn color="primary" @click="getRemainingStudentData()">Get <span class="i-card"> Incomplete /
                                Blocked</span> Student's List</v-btn>
                    </v-col>
                    <v-col sm="3" v-if="std && div && status">
                        <v-btn color="primary" @click="bulk">Proceed to bulk <span class="i-card"> Icard</span>
                            print</v-btn>
                    </v-col>
                </v-row>
                <br />
            </template>
            <template v-if="print_type == 'Specific'">
                    <br>
                    <v-row justify="center" dense>
                        <v-col sm="5">
                            <v-textarea v-model="prn" color="#0F2027" rounded dense label="Enter Comma Seperated PRN"
                                outlined></v-textarea>
                        </v-col>
                    </v-row>
                    <v-row justify="center" dense>
                        <v-col sm="3" v-if="prn">
                            <v-btn color="primary" @click="getStudentIcardSpecificPRN()">Proceed To<span class="i-card">
                                    Icard</span> print</v-btn>
                        </v-col>
                    </v-row>
            </template>
        </v-card>

        <v-card class="box" v-if="icard_data_rem_students != ''">
            <v-data-table :headers="headers" dense :items="icard_data_rem_students" class="elevation-1 mytable"
                id="my-table-id" :search="search">
                <template v-slot:top>
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>Students</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                        <v-text-field style="color: white;background-color: white;" v-model="search"
                            append-icon="search" label="Search" single-line hide-details> </v-text-field>
                        <v-btn v-if="icard_data_rem_students != ''" class="ma-2 no-display" rounded color="white"
                            outlined small @click="fnExcelReport('my-table-id', 'Incomplete student data')"
                            :loading="loader"><v-icon color="white">mdi-export</v-icon>Export</v-btn>
                    </v-toolbar>
                </template>
                <template v-slot:[`item.icard_blocked`]="{ item }">
                    <span v-if="item.icard_blocked">
                        <v-icon small class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                    </span>
                    <span v-else>
                        <v-icon small class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                    </span>
                </template>
            </v-data-table>
        </v-card>
    </div>
</template>
<script>
import axios from "axios";
// import VueBarcode from "vue-barcode";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    components: {
        // barcode: VueBarcode,
    },
    data: () => ({
        prn: "",
        snackbar_msg: "",
        color: "",
        snackbar: false,
        overlay: false,
        search: "",
        itemsPerPage: 10,
        headers: [
            {
                text: "Student",
                align: "left",
                sortable: false,
                value: "grno",
            },
            {
                text: "Data Remaining",
                align: "left",
                sortable: false,
                value: "icard_fields_remaining",
            },
            {
                text: "Is Icard Blocked?",
                align: "left",
                sortable: false,
                value: "icard_blocked",
            },
        ],
        icard_status: null,
        icard_data_rem_students: [],
        icard_temp: [],
        comp_load: false,
        stud_list: null,
        radios: null,
        stud_data: null,
        child_data: null,
        icard_data: [],
        print_type: null,
        std_list: null,
        div_list: null,
        std: null,
        active_status: null,
        div: null,
        status_list: [
            { name: "Active", id: "0" },
            { name: "Temporary Inactive", id: "1" },
            { name: "Permanent Inactive", id: "2" },
        ],
        status: null,
        icard_fields_remaining: null, icard_data: [], common_data: [],
        std_loader: false,
    }),
    mounted() {
        this.onload();
        localStorage.setItem("icard_std_id", null);
        localStorage.setItem("icard_div_id", null);
        localStorage.setItem("icard_data", null);
        localStorage.setItem("common_data", null);
    },
    methods: {
        fnExcelReport(id, name) {
            var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
            tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
            tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
            tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
            tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
            tab_text = tab_text + "<table style='border-collapse:collapse;' border='1'>";
            var exportTable = $("#" + id).clone();
            exportTable.find("input").each(function (index, elem) {
                $(elem).remove();
            });
            exportTable.find(".v-toolbar").remove();
            exportTable.find('th, td').each(function () {
                $(this).css('border', '1px solid black');
            });
            tab_text = tab_text + exportTable.html();
            tab_text = tab_text + "</table></body></html>";
            var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

            const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const filename = name + '.xls';

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            }
        },
        getStudentIcardSpecificPRN() {
            localStorage.setItem("prn", JSON.stringify(this.prn));
            let routeData = this.$router.resolve({
                name: "vvp-stud-specific-card-print",
            });
            window.open(routeData.href, "_blank");
        },
        getRemainingStudentData() {
            this.icard_data_rem_students = [];
            const data = {
                std: this.std,
                div: this.div,
                status: this.status,
            };
            axios
                .post("/Icard/getIcardIncompleteStudent", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.icard_data_rem_students = res.data.icard_data;
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    }
                })
                .catch((error) => {
                    alert("Somthing went wrong!!!");
                })
                .finally(() => {
                    this.comp_load = false;
                });
        },
        bulk() {
            localStorage.setItem("icard_std_id", this.std);
            localStorage.setItem("icard_div_id", this.div);
            localStorage.setItem("icard_learner_status", this.status);
            localStorage.setItem("itemsPerPage", this.itemsPerPage);
            let routeData = this.$router.resolve({
                name: "vvp-stud-bulk-card-print",
            });
            window.open(routeData.href, "_blank");
        },
        onload() {
            this.std_loader = true;
            axios
                .post("/admission/getAllStudents1")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.stud_list = res.data.stud_list;
                        this.std_list = res.data.std_list;
                        this.div_list = res.data.div_list;
                    } else {
                        alert("Something went wrong!!!");
                    }
                })
                .catch((error) => {
                    alert("Something went wrong!!!");
                })
                .finally(() => {
                    this.std_loader = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
};
</script>

<style scoped>
wrap {
    align-self: flex-end;
}

h2 {
    font-size: 1.2em;
}

tr,
td {
    width: 100%;
}

th {
    text-align: left;
    font-size: 0.7em;
    padding-right: 15px;
    padding-left: 6px;
}

@media print {
    .pagebreak {
        page-break-before: always;
    }

    header,
    footer,
    nav,
    date {
        display: none !important;
        margin-top: none !important;
    }

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
        margin-top: none !important;
    }

    v-card {
        border: none !important;
        margin-top: none !important;
    }

    * {
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
    }

    @page {
        size: A4;
        margin-top: none !important;
        padding-top: none !important;
        size: 15.5in 15.5in;
    }
}

.i-card {
    color: greenyellow;
    font-size: medium;
    margin-left: 2px;
    margin-right: 2px;
}
</style>
